export const setInetStatus = status =>({
        type: 'SET_INET_STATUS', payload: status
})

export const setLogged = status =>({type:'SET_LOGGED',payload:status})

export const bkupPersons = persons => ({type: 'BKUP_PERSONS', payload: persons});